import { DialogTitle, Fab, Grid, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";

interface IFullScreenDialogTitleProps {
  title: string;
  onClose: () => void;
}

const FullScreenDialogTitle = (props: IFullScreenDialogTitleProps) => {
  const { title, onClose } = props;

  return (
    <DialogTitle id="fields-dialog-title" disableTypography>
      <Grid container spacing={2}>
        <Grid item xs={2}></Grid>
        <Grid container item xs={8} justify="center">
          <Typography variant="h2">{title}</Typography>
        </Grid>
        <Grid container item xs={2} justify="flex-end">
          <Fab aria-label="close" size="medium" variant="extended" color="secondary" onClick={onClose}>
            <Close />
            Close
          </Fab>
        </Grid>
      </Grid>
    </DialogTitle>
  );
};

export default FullScreenDialogTitle;
